import { render, staticRenderFns } from "./product_phone_bill.vue?vue&type=template&id=3b971180&scoped=true"
import script from "./product_phone_bill.vue?vue&type=script&lang=js"
export * from "./product_phone_bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b971180",
  null
  
)

export default component.exports